import axios from 'axios';

// URL base dell'API per gli allegati , recuperato dall'env file
const ALLEGATO_REST_API_URL = process.env.REACT_APP_API_PREFIX + 'allegato';

const headers = {
    'Content-Type': 'multipart/form-data'
}

class AllegatoService {

    /**
     * Recupera un singolo allegato, contenuto del file compreso.
     * Effettua una richiesta GET a `/allegato/{allId}`.
     *
     * @param {number} allId - ID dell'allegato da recuperare.
     * @returns {Promise} - Una promessa che restituisce l'allegato.
    */
    // AI generated
    getAllegato(allId) {
        return axios.get(ALLEGATO_REST_API_URL + `/${allId}`);
    }

    /**
     * Salva uno o più allegati nel sistema.
     * Effettua una chiamata POST a `/allegato/save` con i dati degli allegati.
     * 
     * @param {Object} allegati -Oggetto contenente i file da salvare.
     * @returns {Promise} - Una promessa che restituisca la risposta del server.
     */
    salvaAllegati(allegati) {
        return axios.post(ALLEGATO_REST_API_URL + "/save", allegati, { headers });
    }
   
    /**
     * Elimina allegati specifici che vengono passati.
     * Effettua una richiesta POST a `/allegato/delete` con un array di oggetti da eliminare.
     *
     * @param {Array<Object>} allegati - Lista degli allegati da eliminare.
     * @returns {Promise} - Una promessa che restituisce la risposta del server.
    */
    eliminaAllegati(allegati) {
        return axios.post(ALLEGATO_REST_API_URL + "/delete",  JSON.stringify(allegati), { headers: {
            'Content-Type': 'application/json'
        } });
    }

    /**
     * Elimina allegati specifici in base ai loro ID.
     * Effettua una richiesta POST a `/allegato/delete-by-id` con un array di ID da eliminare.
     * Da preferire a `eliminaAllegati`: non rispedisce al server il contenuto dei file.
     *
     * @param {Array<number>} allegatiIds - Lista degli ID degli allegati da eliminare.
     * @returns {Promise} - Una promessa che restituisce la risposta del server.
    */
    // AI generated
    eliminaAllegatiById(allegatiIds) {
        return axios.post(ALLEGATO_REST_API_URL + "/delete-by-id", allegatiIds, { headers: {
            'Content-Type': 'application/json'
        } });
    }
}

// Creazione dell'istanza per essere importata direttamente nei componenti
const allegatoServiceInstance = new AllegatoService();
export default allegatoServiceInstance;
